import React from "react";
import {
  DonationsWrapper,
  DonationsButtons,
  DonationButton,
  DonationsCopy,
} from "../styles/Game.styles";

export default function Donations() {
  function openExternal(url) {
    if (!url) return;
    window.open(url, "_blank", "noopener,noreferrer");
  }
  return (
    <DonationsWrapper>
      <DonationsCopy>
        Enjoying the game?
        <br />
        Tips help keep the camp open!
      </DonationsCopy>
      <DonationsButtons>
        <DonationButton
          onClick={() =>
            openExternal("https://donate.stripe.com/7sYeVddSm2V09PVf8vdjO00")
          }
        >
          Tip via Stripe
        </DonationButton>
        <DonationButton
          onClick={() =>
            openExternal("https://buymeacoffee.com/summercampslasher")
          }
        >
          Buy Me a Coffee
        </DonationButton>
      </DonationsButtons>
      <DonationsCopy>or Venmo: @summercampslasher</DonationsCopy>
    </DonationsWrapper>
  );
}
